<template>
    <div class="slide trivia-10">
        <TriviaCard :currentTrivia="currentTrivia" :title="questions.question.title"
                    :answers="questions.question.answers"
                    :correctAnswer="questions.question.correctAnswer"
                    :nextRoute="nextRoute"
                    :current="4"
                    :total="4"
                    :selectAll=true
                    :className="className" />

    </div>
</template>

<script>
import TriviaCard from '@/components/TriviaCard.vue'

export default {
    name: 'trivia',
    components: {
        TriviaCard,
    },
    data() {
        return {
            nextRoute: "cruella-dewalt",
            className: "trivia-10",
            currentTrivia: 10,
            questions: {
                question: {
                    "title": "Which of the following should you include in your case or investigation file documentation?",
                    "answers": [
                        {"key": "A", "answer": "Photographs of empty packages"},
                        {"key": "B", "answer": "CCTV evidence"},
                        {"key": "C", "answer": "Witness statements"},
                        {"key": "D", "answer": "Apprehension report"}
                    ],
                    "correctAnswer": ["A", "B", "C", "D"]
                }
            }
        }
    },
  mounted() {
    window.setTimeout(() => {
          window.scrollTo(0,1)
        }, 1000)
  }
}
</script>

<style lang="scss">
.trivia-10 {

    h1 {
        font-size: 28px !important;
        line-height: 1.3;
    }
}
</style>
